import type { ComponentStackEntry } from "./types";

/** Production builds minify component names to short tokens (e.g. e7, S, d, 3). */
export function isMinifiedComponentName(name: string): boolean {
  if (!name || name === "Anonymous") {
    return true;
  }

  if (/^\d+$/.test(name)) {
    return true;
  }

  return name.length <= 3 && /^[A-Za-z]\d*$/.test(name);
}

export function formatMeaningfulComponentStack(
  stack: ComponentStackEntry[],
  separator = " > "
): string {
  return stack
    .map((entry) => entry.name)
    .filter((name) => !isMinifiedComponentName(name))
    .join(separator);
}
